import { css } from "@emotion/css"
import { useEffect, useRef, useId } from "react"

import TextInput from "../input/TextInput"
import Radio from "./Radio"

type Props = React.ComponentProps<typeof Radio> & {
  description: string
  textInputProps: React.ComponentProps<typeof TextInput>
}

/**
 * ラジオボタンの選択肢の中に「その他」のような選択肢があり、それを選択した場合にテキストを自由入力できるユースケースを想定しています。
 */
const RadioWithTextInput = ({ description, textInputProps, children, ...radioProps }: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  useEffect(() => {
    if (radioProps.checked) {
      inputRef.current?.focus()
    }
  }, [radioProps.checked])

  const labelId = useId()
  const describeId = useId()

  return (
    <div className={styles.container}>
      <div className={styles.radioContainer}>
        <Radio {...radioProps}>
          <span id={labelId}>{children}</span>
        </Radio>
        <span id={describeId} className={styles.description}>
          {description}
        </span>
      </div>
      <TextInput
        ref={inputRef}
        {...textInputProps}
        disabled={!radioProps.checked || textInputProps.disabled}
        aria-labelledby={labelId}
        aria-describedby={describeId}
      />
    </div>
  )
}
export default RadioWithTextInput

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    row-gap: 7.5px;
  `,
  radioContainer: css`
    display: flex;
  `,
  description: css`
    color: #999999;
  `,
}
